export enum DeviceConnectMode {
  Normal = 0x00,
  M_USB = 0x01,
  Wireless24G = 0x02,
  Wireless24G8K = 0x03,
}

export enum DeviceType {
  mouse = 0x01,
  keyboard,
}

export enum MagnetSeniorType {
  SeniorKeyTypeNone = 0,
  SeniorKeyTypeDKS = 1,
  SeniorKeyTypeMT = 2,
  SeniorKeyTypeTGL = 3,
  SeniorKeyTypeMPT = 4,
  SeniorKeyTypeEND = 5,
  SeniorKeyTypeKME = 6,
  SeniorKeyTypeRS = 7,
}

export enum SeniorKMEType {
  Default = 0,
  AFirst = 1,
  BFirst = 2,
  Neutral = 3,
}

export enum DeviceState {
  StateUnlink = 0,
  StateLinkSuccessful = 1,
  StateLinking = 2,
}

export enum SpecificItemAction {
  Read,
  Write,
}

export enum SpecificItem {
  LockWin = 'LockWin',
  SuperResponsiveMode = 'SuperResponsiveMode',
  DeadZone = 'DeadZone',
  Rate = 'Rate',
  SleepTime = 'SleepTime',
  PollingRate = 'PollingRate',
  SensorLod = 'SensorLod',
  SensorMotionSync = 'SensorMotionSync',
  SensorMode = 'SensorMode',
  MouseDebounce = 'MouseDebounce',
  PowerLevel = 'PowerLevel',
  PowerIsCharging = 'PowerIsCharging',

  RTStab = 'RTStab',
  BluetoothSleepTime = 'BluetoothSleepTime',
  PreventAccidentalTouch = 'PreventAccidentalTouch', //键盘防误触

  RippleControl = 'RippleControl', //波纹控制
  LineCorrection = 'LineCorrection', //直线修正
  LongDistance = 'LongDistance', //远距离模式
  HighPerformance = 'HighPerformance', //高性能模式
  HighPerformanceState = 'HighPerformanceState', // 高性能模式状态

  KeyboardDebounce = 'KeyboardDebounce',

  FastScanningTime = 'FastScanningTime',
  RTScanningTime = 'RTScanningTime',

  IMCStatus = 'IMCStatus', // IMC状态

  RunMode = 'RunMode', // 运行模式
  LockKeyboard = 'LockKeyboard', // 锁定键盘
  DirectionKeySwap = 'DirectionKeySwap', //对调ASDW和方向键(火柴人方案)
  KeyMode = 'KeyMode', // Key模式  0：全键无冲模式  1:6KEY模式(火柴人方案)
  BacklightClose = 'BacklightClose', //关闭背光
  SideLedClose = 'SideLedClose', //关闭侧灯
  CancelDefaultDeadZone = 'CancelDefaultDeadZone', //   取消默认死区
  CancelDefaultBottomDeadZone = 'CancelDefaultBottomDeadZone', // 取消默认底部死区（v1.20+）
  CancelDefaultTopDeadZone = 'CancelDefaultTopDeadZone', // 取消默认顶部死区（v1.20+）
}

export enum MagnetKeyType {
  DKS = 0x01,
  MPT = 0x02,
  MT = 0x03,
  TGL = 0x04,
  END = 0x05,
  Macro = 0x06,
  KME = 0x08,
  RS = 0x09,
}

export enum KeyZone {
  normalKey = 0b00000001, //基础字符区
  extendKey = 0b00000010, //扩展字符区
  media = 0b00000100, //媒体区
  mouse = 0b00001000, //鼠标区
  modifierKey = 0b00010000, //修饰键
}
export enum KeyGroup {
  none = '',
  unknown = 'unknown', // 无法确认的轴体或存在多种轴体 - 默认轴体
  cipo = 'cipo', // 磁珀轴
  tianqing = 'tianqing', // 天青轴
  tianqing_Pro = 'tianwangPro', // 天青磁轴Pro版
  zixing = 'zixing', // 紫星轴
  ciyu = 'ciyu', // 磁玉轴
  wanciwang = 'wanciwang', // 万磁王轴
  tianwang_SE = 'tianwangSE', // 天王磁轴SE版
  tianwang_Standard = 'tianwangStandard', // 天王磁轴标准版
  tianwang_Esports = 'tianwangEsports', // 天王磁轴电竞版
  xingguang = 'xingguang', // 星光轴
  qinghui = 'qinghui', // 清辉轴
  qinghui_pro = 'qinghuipro', // 清辉轴
  TianShanGT = 'TianShanGT', // 泰山GT
  BaBao = 'BaBao', // 八宝轴
  CiyuPro = 'CiYuPro', // 磁玉Pro
  CiyuGaming = 'CiYuGaming', // 磁玉Gaming
}

export enum MusicCaptureStatus {
  None = 0,
  Start = 1,
  Pause = 2,
  Continue = 3,
  Stop = 4,
}

//配对状态
export const CompxPairResult = {
  None: 0x00,
  Pairing: 0x01,
  Fail: 0x02,
  Success: 0x03,
}
// 进入升级模式  升级中  升级完成
export enum FirmwareUpgradeStatus {
  None = 0x00,
  AppToBoot = 0x01,
  Upgrading = 0x02,
  BootToApp = 0x03,
}
